// extracted by mini-css-extract-plugin
export default {"layoutHero":"layoutHero_bsUjk","isFullWidthTitle":"isFullWidthTitle_TQdrd","content":"content_w0NEf","title":"title_KbF64","picture":"picture_S61et"};